import { configureStore } from '@reduxjs/toolkit';
import alertReducer from './AlertSlice';

const alertStore = configureStore({
  reducer: {
    alert: alertReducer,
  }
});

export default alertStore;